import { render, staticRenderFns } from "./companyTitle.vue?vue&type=template&id=3026b3f6&scoped=true&"
import script from "./companyTitle.vue?vue&type=script&lang=js&"
export * from "./companyTitle.vue?vue&type=script&lang=js&"
import style0 from "./companyTitle.vue?vue&type=style&index=0&id=3026b3f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3026b3f6",
  null
  
)

export default component.exports